export var getContactByType = function getContactByType(allowedContacts, contacts, type) {
  var _contacts$filter$;
  return allowedContacts !== null && allowedContacts !== void 0 && allowedContacts.includes(type) ? contacts === null || contacts === void 0 ? void 0 : (_contacts$filter$ = contacts.filter(function (contact) {
    return (contact === null || contact === void 0 ? void 0 : contact.type) === type;
  })[0]) === null || _contacts$filter$ === void 0 ? void 0 : _contacts$filter$.value : null;
};